/**
 * Configure axios session with runtime baseURL and auth token from cookie.
 * Ensures all requests via the session instance use credentials and Token when present.
 */
import session from "~/shared/services/session";

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();
  const tokenCookie = useCookie<string | null>("token", { default: () => null });

  session.defaults.baseURL = config.public.baseURL as string;
  session.defaults.withCredentials = true;

  session.interceptors.request.use((reqConfig) => {
    const token = tokenCookie.value;
    if (token) {
      reqConfig.headers.Authorization = `Token ${token}`;
    }
    return reqConfig;
  });
});
